let locales = {
    parameterList_title: "Pop-up Contatti",
    parameterList_key: "KEY",
    parameterList_description: "Descrizione",
    parameterList_value: "Valore",
    parameterList_type: "Tipa",
};

export default locales;